export default "__VITE_ASSET__d19099a2__"